import React from 'react';
import { ArrowRight } from 'lucide-react';
export default function ClubAbout({ onEnter }) {
  return <section className="club-about"><p className="club-eyebrow">TAP TENNIS CLUB</p><h1>TAP 소개</h1><p className="club-about-copy">제주대학교 테니스 동아리<br />일정 · 경기 기록 · 클럽 랭킹</p>
    {onEnter && <button className="club-button" onClick={onEnter}>회원 공간으로 <ArrowRight size={18} aria-hidden="true" /></button>}
    <div className="club-about-values"><div><span>01</span><h2>클럽 일정</h2><p>다가오는 운동과 대회 소식을 확인하세요.</p></div><div><span>02</span><h2>경기 기록</h2><p>코트 위의 순간을 기록으로 남깁니다.</p></div><div><span>03</span><h2>클럽 랭킹</h2><p>전적과 레이팅으로 변화를 살펴보세요.</p></div></div>
  </section>;
}
